/* ============ Briar Botanics — Theme JS ============ */
document.addEventListener('DOMContentLoaded', function() {

  // Mobile menu
  var toggle = document.querySelector('.menu-toggle');
  var navLeft = document.querySelector('.nav-left');
  if (toggle && navLeft) {
    toggle.addEventListener('click', function() { navLeft.classList.toggle('open'); });
  }

  // Accordions
  document.querySelectorAll('.accordion-item button').forEach(function(btn) {
    btn.addEventListener('click', function() {
      btn.closest('.accordion-item').classList.toggle('open');
    });
  });

  // Testimonial carousel
  var slides = document.querySelectorAll('.t-slide');
  var dots   = document.querySelectorAll('.t-dots button');
  var tIndex = 0;
  function showSlide(i) {
    slides.forEach(function(s,idx){ s.classList.toggle('active', idx===i); });
    dots.forEach(function(d,idx){ d.classList.toggle('active', idx===i); });
    tIndex = i;
  }
  dots.forEach(function(d){ d.addEventListener('click', function(){ showSlide(parseInt(d.dataset.i)); }); });
  if (slides.length) setInterval(function(){ showSlide((tIndex+1)%slides.length); }, 6000);

  // Newsletter forms
  document.querySelectorAll('form.newsletter-form').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var msg = form.querySelector('.form-msg');
      if (msg) msg.classList.add('show');
      form.reset();
    });
  });

  // PDP gallery
  document.querySelectorAll('.thumb-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.thumb-btn').forEach(function(b){ b.classList.remove('active'); });
      btn.classList.add('active');
      var main = document.getElementById('mainImg');
      if (main) {
        main.src = btn.dataset.src;
        if (btn.dataset.blend === 'true') { main.classList.add('blend'); }
        else { main.classList.remove('blend'); }
      }
    });
  });

  // Bundle selector
  var savingsMap = {
    '1': '',
    '2': 'Save 28% — $20 per bottle',
    '3': 'Buy 2 Get 1 Free — Save $28'
  };
  document.querySelectorAll('.bundle-card').forEach(function(card) {
    card.addEventListener('click', function() {
      document.querySelectorAll('.bundle-card').forEach(function(c){ c.classList.remove('active'); });
      card.classList.add('active');
      var price = parseFloat(card.dataset.price);
      var p = '$' + price.toFixed(2);
      var pd = document.getElementById('priceDisplay');
      var ab = document.getElementById('addBtnPrice');
      var sb = document.getElementById('savingsBadge');
      if (pd) pd.textContent = p;
      if (ab) ab.textContent = p;
      if (sb) sb.textContent = savingsMap[card.dataset.bundle] || '';
    });
  });

});
